import React from 'react'
import Image from 'next/image'
import Link from 'next/link'
import { Button } from 'semantic-ui-react'

import { styles } from './styles'

export const SignInTile = () => {
  return (
    <div style={styles.container}>
      <div style={styles.infoContainer}>
        <div style={styles.logoContainer}>
          <Image
            src='/small-enlyt-logo.png'
            alt='Enlyt Health'
            width={200}
            height={60}
            style={{ maxWidth: '100%', height: 'auto' }}
          />
        </div>
        <div style={styles.signInText}>
          Sign in or<br/> sign up
        </div>
        <div style={styles.description}>
          Sign in to view your insurance coverage, eligibility, claim<br/> status, family deductible status and more
        </div>
      </div>
      <Link href={'/'}>
        <Button style={styles.signInButton}>
          Sign in
        </Button>
      </Link>
    </div>
  )
}
